// @flow
import { shorterDate, shorterTime } from 'utils/date';
import { getCookieValue } from 'utils/cookies';

export const formatEventTime = (
  localizedStarts: Date,
  localizedEnds: ?Date
) => {
  let formattedTime = `${shorterDate(localizedStarts)}, ${shorterTime(
    localizedStarts
  )}`;
  if (localizedEnds) {
    formattedTime += ` - ${shorterTime(localizedEnds)}`;
  }
  return formattedTime;
};

export const combineFormDateTime = (date: string, time: string) =>
  `${date}T${time}`;

export const splitFormDateTime = (
  dt: string
): { date: ?string, time: ?string } => {
  const dateParts = dt.split('T');
  return { date: dateParts[0], time: dateParts[1] };
};

export const isEnabled = () => getCookieValue('_idealistDaysEnabled') === '1';
